// Same rules as the mobile app's utils/validateDisplayName.ts, so a name that
// works on one platform works on the other. The banned list matches
// roomCreationService's room-name list.
const BANNED_WORDS = ["fuck", "shit", "damn", "bitch", "ass", "hell"];

export const MAX_DISPLAY_NAME_LENGTH = 16;

export function validateDisplayName(raw) {
  const name = (raw || "").trim();

  if (!name) {
    return { isValid: false, message: "Please enter a name" };
  }

  if (name.length > MAX_DISPLAY_NAME_LENGTH) {
    return { isValid: false, message: `Name must be ${MAX_DISPLAY_NAME_LENGTH} characters or less` };
  }

  // Whole words only, so names like Michelle, Hassan or Cassandra pass.
  const words = name.toLowerCase().split(/[^a-z]+/);
  if (BANNED_WORDS.some((word) => words.includes(word))) {
    return { isValid: false, message: "Please choose a different name" };
  }

  return { isValid: true };
}

/** "Simi Dickson" → "Simi": the in-game name an account starts with. Rooms
 *  show first names; the full account name stays on the sign-in profile. */
export function firstNameOf(fullName) {
  return (fullName || "").trim().split(/\s+/)[0].slice(0, MAX_DISPLAY_NAME_LENGTH);
}
